export const companiesManagementSelector = (state) => state.companiesManagement;